module.exports = function getResource(label, vars = []) {
    let resources = {
        signIn: 'Sign In',
        biHeading: 'Beauty Insider Summary',
        biDesc: 'View activity, savings, benefits',
        biDescJoin: 'Join now to start saving & collect points',
        joinNow: 'Join Now',
        rewardsHeading: 'Rewards Bazaar',
        rewardsDesc: 'Redeem items, samples, more',
        pointsLabel: `Point${vars[0]}`,
        chooseBirthdayGift: 'Choose your Birthday gift!',
        ccHeading: 'Sephora Credit Card Program',
        ccDesc: 'Manage credit card and rewards',
        ccRewardsLabel: 'Rewards',
        ccApplyNow: 'Apply now',
        ordersHeading: 'Orders',
        ordersDesc: 'View & track online or pickup orders',
        purchasesHeading: 'Buy It Again',
        purchasesDesc: 'Reorder from in-store and online purchases',
        lovesHeading: 'Loves',
        lovesDesc: 'View saved products',
        recHeading: 'Beauty Advisor Recommendations',
        recDesc: 'Recommendations from your store visits',
        reservationsHeading: 'Reservations',
        reservationsDesc: 'Manage your services, classes, events',
        ciqHeading: 'Beauty Traits & Color iQ',
        ciqDesc: 'Complete your beauty traits for personalized recommendations',
        accountHeading: 'Account Settings',
        accountDesc: 'Payment, contact info, addresses, password',
        signOut: 'Sign Out',
        flashHeading: 'Flash',
        flashDesc: 'Unlimited 1-2 Day Shipping Subscription'
    };

    return resources[label];
};
